module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Friedrich A. Hayek\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("F. A. Hayek")]), _vm._v(" (1899-1992), recipient of the Medal of Freedom in 1991 and co-winner of the Nobel Memorial Prize in Economics in 1974, was a pioneer in monetary theory and a leading proponent of classical liberalism  in the twentieth century. He taught at the University of London, the University of Chicago, and the University of Freiburg."), _c('br')], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/mIZ0Op/tc-custom/9780226321264.jpg?1738725923459",
      "alt": "This image is the cover for the book Law, Legislation and Liberty, Volume 3, Law, Legislation and Liberty"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Law, Legislation and Liberty, Volume 3, Law, Legislation and Liberty\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Incisive, straightforward, and eloquent, this third and concluding volume of F. A. Hayek's comprehensive assessment of the basic political principles which order and sustain free societies contains the clearest and most uncompromising exposition of the political philosophy of one of the world's foremost economists."), _c('br')]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The University of Chicago Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0